import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=212a5890&scoped=true"
import script from "./DocumentsTable.vue?vue&type=script&lang=ts"
export * from "./DocumentsTable.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsTable.vue?vue&type=style&index=0&id=212a5890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a5890",
  null
  
)

export default component.exports